<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />

        <div v-else>
          <crud-list
            v-model="planos"
            :headers="headers"
            :actions="actions"
            :sort-by="['codigo','nome']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template v-slot:btnCadastro>
              <v-col>
                <v-btn
                  block
                  class="text-none text-white"
                  color="primary"
                  title="Cadastrar novo plano de pagamento"
                  rounded
                  @click="$router.push({ path: 'plano-pagamento/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import PlanosPagamento, { BOOTSTRAP, INATIVAR_PLANO_PAGAMENTO } from '@/store/modules/planosPagamento'
  import { mapState, mapActions } from 'vuex'
  export default {
    data () {
      return {
        actions: [
          {
            title: 'Editar plano de pagamento',
            color: 'info darken-3',
            click: item => this.editarPlanoPagamento(item),
            icon: 'mdi-pencil',
          },
          {
            title: 'Excluir plano de pagamento',
            color: 'red darken-3',
            click: item => this.INATIVAR_PLANO_PAGAMENTO(item),
            icon: 'mdi-trash-can-outline',
          },
        ],
        headers: [
          { text: '', value: 'actions', sortable: false, groupable: false, floatingfilter: false, width: '40px' },
          {
            align: 'left',
            sortable: true,
            floatingfilter: true,
            groupable: false,
            text: 'Descrição',
            value: 'descricao',
            width: 'auto',
            report: true,
          },
          {
            align: 'left',
            sortable: true,
            groupable: false,
            floatingfilter: true,
            text: 'Tabela',
            value: 'tabela',
            width: 'auto',
            report: true,
          },
        ],
      }
    },
    computed: {
      ...mapState('planosPagamento', ['loading', 'planos']),
    },
    async created () {
      if (!this.$store.hasModule('planosPagamento')) { this.$store.registerModule('planosPagamento', PlanosPagamento) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('planosPagamento', [BOOTSTRAP, INATIVAR_PLANO_PAGAMENTO]),
      editarPlanoPagamento ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/cdc/plano-pagamento/alterar`,
          query: { id },
        })
      },
    },
  }
</script>
